import type { RouteLocationNormalizedLoaded } from 'vue-router'

export interface ErrorEntry {
  message: string
  status?: number | null
  url?: string | null
  at: string
}

export interface PageContext {
  route_path: string
  route_name: string | null
  page_title: string
  url: string
  related_client_id: string | null
  related_employee_id: string | null
  recent_errors: ErrorEntry[]
  triggering_error: ErrorEntry | null
  user_agent: string
  viewport: { w: number; h: number }
  captured_at: string
}

export function capturePageContext(
  route: RouteLocationNormalizedLoaded,
  opts: { recentErrors?: ErrorEntry[]; triggeringError?: ErrorEntry | null } = {},
): PageContext {
  return {
    route_path: route.path,
    route_name: (route.name as string) ?? null,
    page_title: document.title,
    url: window.location.href,
    related_client_id:
      (route.params.clientId as string) ??
      (route.name === 'transportation-client-detail' || route.name === 'compliance-client-detail'
        ? (route.params.id as string)
        : null) ??
      null,
    related_employee_id: (route.params.employeeId as string) ?? null,
    recent_errors: opts.recentErrors ?? [],
    triggering_error: opts.triggeringError ?? null,
    user_agent: navigator.userAgent,
    viewport: { w: window.innerWidth, h: window.innerHeight },
    captured_at: new Date().toISOString(),
  }
}
